import autobind from 'autobind-decorator';
import * as React from 'react';
import { Field } from 'redux-form';

import { ImageUploader } from 'common/components/image-uploader';
import { StateStatus } from 'common/interfaces/account';
import { KreoButton } from 'common/UIKit';
import { CommonsApi } from '../../../../../api/common';
import { Required } from '../../../../../components/dialog/validators';
import { AccountApi } from '../../../api';
import { MaterialInputField } from '../../field-input';
import { Styled } from './styled';

type MaterialInputProps = any;

interface Props {
  setImage: (name: string) => void;
  deleteImage: () => void;
  userId: string;
  hasAvatar: boolean;
  accountStatus: StateStatus;
  canEditCompany: boolean;
  submitDisabled: boolean;
}

const validateRequired = [Required];

export class ProfileSection extends React.Component<Props> {
  public render(): React.ReactNode {
    const { accountStatus, userId, hasAvatar, submitDisabled } = this.props;
    let err = null;
    if (accountStatus.hasError) {
      err = <div className='profile-section__error'>{accountStatus.message}</div>;
    }

    if (!userId) {
      return null;
    }
    const avatarLink = AccountApi.buildAvatarLinkPostfix(userId, hasAvatar);

    return (
      <Styled.Container>
        <Styled.ContentContainer>
          <ImageUploader
            previewUrl={CommonsApi.tempFileLink}
            defaultImagePreviewUrl={avatarLink}
            deleteImage={this.props.deleteImage}
            onLoadEnd={this.setImage}
          />

          <Styled.FieldWrap>
            <Field<MaterialInputProps>
              className='profile-section__material-input'
              name='email'
              component={MaterialInputField}
              text='Email'
              autocomplete='email'
              disabled={true}
            />
            {err}
            <Styled.ContentContainer>
              <Field<MaterialInputProps>
                name='firstName'
                component={MaterialInputField}
                className='profile-section__material-input'
                text='First Name'
                validate={validateRequired}
                autocomplete='name'
              />
              <Field<MaterialInputProps>
                name='lastName'
                component={MaterialInputField}
                className='profile-section__material-input'
                text='Last Name'
                validate={validateRequired}
                autocomplete='family-name'
              />
            </Styled.ContentContainer>

            {false && this.props.canEditCompany && (
              <Field<MaterialInputProps>
                name='companyName'
                component={MaterialInputField}
                className='profile-section__material-input'
                text='Company'
                validate={validateRequired}
                autocomplete='organization'
              />
            )}

            <Styled.ContentContainer>
              <Field<MaterialInputProps>
                name='oldPassword'
                component={MaterialInputField}
                className='profile-section__material-input'
                text='Old Password'
                type='text'
                autocomplete='old-password'
                title=''
              />
              <Field<MaterialInputProps>
                name='newPassword'
                component={MaterialInputField}
                className='profile-section__material-input'
                text='New Password'
                type='text'
                autocomplete='new-password'
                title=''
              />
            </Styled.ContentContainer>
            <Styled.Button>
              <KreoButton
                htmlButtonType='submit'
                mode='submit'
                size='large'
                caption='Save changes'
                disabled={submitDisabled}
              />
            </Styled.Button>
          </Styled.FieldWrap>
        </Styled.ContentContainer>
      </Styled.Container>
    );
  }

  @autobind
  private setImage(err: any, response: string): void {
    if (!err) {
      this.props.setImage(response);
    }
  }
}
